import numeral from 'numeral'
import {formatRapDiscount} from './format-diamond'

export const TableCellWidth = {
  checkbox: 46,
  stockNumber: 98,
  pairSort: 70,
  seller: 90,
  shape: 118,
  carat: 60,
  colour: 68,
  clarity: 60,
  cut: 50,
  polish: 50,
  symmetry: 50,
  fluorescence: 45,
  perCaratPrice: 100,
  rapDiscount: 60,
  price: 105,
  lab: 56,
  photo: 52,
  depth: 70,
  table: 57,
  measurements: 138
}

export const PriceFieldNameByMarkupAndCurrency = (markupType, currency) => {
  currency = currency.toUpperCase()
  if (markupType === 'CP') {
    return 'Cost Price ' + currency
  } else if (markupType === 'BP') {
    return 'Base Price ' + currency
  } else if (markupType === 'SP') {
    return 'Sale Price ' + currency
  }
}

export const PerCaratFieldNameByMarkupAndCurrency = (markupType, currency) => {
  currency = currency.toUpperCase()
  if (markupType === 'CP') {
    return 'Price Per Carat Cost Price ' + currency
  } else if (markupType === 'BP') {
    return 'Price Per Carat Base Price ' + currency
  } else if (markupType === 'SP') {
    return 'Price Per Carat Sale Price ' + currency
  }
}

export const RapDiscountFieldNameByMarkup = (markupType) => {
  if (markupType === 'CP') {
    return 'Rap CP Discount'
  } else if (markupType === 'BP') {
    return 'Rap BP Discount'
  } else if (markupType === 'SP') {
    return 'Rap SP Discount'
  }
}

export const PriceByMarkupAndCurrency = (markupType, currency, row) => {
  // given the price as 00000, formats it to 00,000
  return numeral(row[PriceFieldNameByMarkupAndCurrency(markupType, currency)]).format('0,0')
}

export const PricePerCaratByMarkupAndCurrency = (markupType, currency, row) => {
  // given the price as 00000, formats it to 00,000
  return numeral(row[PerCaratFieldNameByMarkupAndCurrency(markupType, currency)]).format('0,0')
}

export const RapDiscountByMarkup = (markupType, row) => {
  return formatRapDiscount(row[RapDiscountFieldNameByMarkup(markupType)])
}

export const LastFiveDigitsForHash = (hashIdField) => {
  return (hashIdField) ? hashIdField.substr(-5) : '-'
}



// WEBPACK FOOTER //
// ./src/utils/diamond-search-result.js